import { UserAdminEventType } from './../user-admin.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { Quint, TweenMax } from 'gsap';
import { SharedService } from '../../../shared/shared.service';

@Component({
	selector: 'app-new-user-confirmation',
	templateUrl: './new-user-confirmation.component.html',
	styleUrls: ['./new-user-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class NewUserConfirmationComponent implements OnInit, OnDestroy {

	message: string;
	type: string;
	active = false;
	view = '[data-component="new-user-confirmation"]';

	constructor(public sharedService: SharedService) { }

	ngOnInit() {

		AppEventDispatcher.listen(UserAdminEventType.USER_CONFIRM, (data) => {

			this.message = data.message;
			this.type = data.type;

			if (data.show) {
				this.active = true;
				this.show();
			} else {
				this.hide();
			}

		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(UserAdminEventType.USER_CONFIRM);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + 50;
	}

	show() {
		const timer = setInterval(() => {
			if ($(this.view).length > 0) {

				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});

				clearInterval(timer);
			}
		}, 10);
	}

	hide() {
		TweenMax.to(this.view, .8, { left: '150%', ease: Quint.easeOut});
		AppEventDispatcher.dispatch(UserAdminEventType.USER_FORM, { show: true });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/user-admin/new-user-confirmation/new-user-confirmation.component.ts